import { customEvent } from '@jspartials/general-utils';

let lazyVideoObserver = null;

const loadVideo = (video) => {
  const sources = video.querySelectorAll('source');

  sources.forEach((videoSource) => {
    if (videoSource.dataset.src) {
      videoSource.src = videoSource.dataset.src;
    }
  });

  video.addEventListener('play', () => {
    video.style.removeProperty('aspect-ratio');
  });

  video.load();

  if (video.hasAttribute('autoplay')) {
    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(() => {});
    }
  }

  video.classList.remove('hw-lazy-video');
};

const getObserver = () => {
  if (lazyVideoObserver) {
    return lazyVideoObserver;
  }

  if ('IntersectionObserver' in window) {
    lazyVideoObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadVideo(entry.target);
          observer.unobserve(entry.target);
        }
      });
    });
  }

  return lazyVideoObserver;
};

const initLazyVideos = () => {
  const lazyVideos = Array.from(
    document.querySelectorAll('video.hw-lazy-video')
  );

  const observer = getObserver();

  if (observer) {
    lazyVideos.forEach((lazyVideo) => {
      observer.observe(lazyVideo);
    });
  } else {
    lazyVideos.forEach((video) => {
      loadVideo(video);
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  initLazyVideos();
});

document.addEventListener('afterUpdateContentOfProductDetailPage', () => {
  initLazyVideos();
});

document.addEventListener(customEvent.initLazyVideos, () => {
  initLazyVideos();
});

export { initLazyVideos };

